// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3_Gsz","left":"InfoRow_left__1D9GT"};